import EDUTECH_LOGO from "../Images/NavbarImages/edutech.svg"
// import HOME_HERO from "../Images/Home/home-hero.png"
// import  HOME_BATCH_1 from "../Images/Home/home-batch-1.png"
import SEARCH_ICON from '../Images/NavbarImages/SearchOutline.svg'

import HERO_MAIN_BAR from '../Images/Home Images/Header Content.png'

import  PARTNERS from '../Images/common/Partners.png'

import HOME_HERO from "../Images/Home Images/home-hero.png"
import CARD_IMG from "../Images/Home Images/Card Image.png"
import HOME_ICON_1 from "../Images/Home Images/icon-1.svg"
import HOME_ICON_2 from "../Images/Home Images/icon-2.svg"
import HOME_ICON_3 from "../Images/Home Images/icon-3.svg"
import HOME_ICON_4 from "../Images/Home Images/icon-4.svg"

import HOME_DEMO_1 from '../Images/Home Images/demo1.png'
import HOME_DEMO_2 from '../Images/Home Images/demo2.png'
import HOME_DEMO_3 from '../Images/Home Images/demo3.png'

import HOME_BUSINESS_HERO from '../Images/HomeBusiness/business-hero.png'
import HOME_BUSSINESS_ASIDE from '../Images/HomeBusiness/Aside.png'


import HOME_UNIVERSITY_HERO from '../Images/HomeUniversities/university-hero.png'
import HOME_UNIVERSITY_LEFT_ASIDE from '../Images/HomeUniversities/LeftAside.png'
import HOME_UNIVERSITY_RIGHT_ASIDE from '../Images/HomeUniversities/RightAside.png'


import TRAINING_HERO from '../Images/TrainingImages/hero.png'

import  ABOUT_ASIDE  from "../Images/AboutImges/aside.png"
import ABOUT_HERO from '../Images/AboutImges/hero.png'
import ABOUT_ICON from '../Images/AboutImges/icon.svg'
import ABOUT_ARROW_ICON from "../Images/AboutImges/arrow-Icon.png"

import CHEVRON_DOWN from '../Images/common/ChevronDownOutline.svg'
import CHEVRON_UP from '../Images/common/ChevronUpOutline.svg'
import CHEVRON_RIGHT from '../Images/common/ChevronRight.svg'

import CALENDER_ICON from '../Images/common/uil_calender.svg'
import LIVE_ICON from '../Images/common/live-icon.svg'
import VERIFIED_ROUNDED_ICON from '../Images/common/material-symbols_verified-rounded.svg'

import LOCK_ICON from '../Images/common/lock.svg'


import COURSE_ICON_1 from '../Images/Courses/courseIcons/Icons.svg'
import COURSE_ICON_2 from '../Images/Courses/courseIcons/Icons-1.svg'
import COURSE_ICON_3 from '../Images/Courses/courseIcons/Icons-2.svg'
import COURSE_ICON_4 from '../Images/Courses/courseIcons/Icons-3.svg'
import COURSE_ICON_5 from '../Images/Courses/courseIcons/Icons-4.svg'
import COURSE_ICON_6 from '../Images/Courses/courseIcons/Icons-5.svg'
import COURSE_ICON_7 from '../Images/Courses/courseIcons/Icons-6.svg'
import COURSE_ICON_8 from '../Images/Courses/courseIcons/Icons-7.svg'
import COURSE_ICON_9 from '../Images/Courses/courseIcons/Icons-8.svg'



import BANKING_HERO_1 from "../Images/Courses/Banking and finance/banking-hero-1.png"
import  BANKING_COURSE_1  from "../Images/Courses/Banking and finance/banking-courses-1.png"
import BANKING_ICON_1 from "../Images/Courses/Banking and finance/icon-1.png"
import BANKING_ICON_2 from "../Images/Courses/Banking and finance/icon-2.png"
import BANKING_ICON_3 from "../Images/Courses/Banking and finance/icon-3.png"
import BANKING_ICON_4 from "../Images/Courses/Banking and finance/icon-4.png"
import BANKING_ICON_5 from "../Images/Courses/Banking and finance/icon-5.png"
import BANKING_ICON_6 from "../Images/Courses/Banking and finance/icon-6.png"
import BANKING_ICON_7 from "../Images/Courses/Banking and finance/icon-7.png"

import BANKING_ACCORDIAN_1 from '../Images/Courses/Banking and finance/bankingAccordian-1.png'
import BANKING_ACCORDIAN_2 from '../Images/Courses/Banking and finance/bankingAccordian-2.png'
import BANKING_ACCORDIAN_3 from '../Images/Courses/Banking and finance/bankingAccordian-3.png'
import BANKING_ACCORDIAN_4 from '../Images/Courses/Banking and finance/bankingAccordian-4.png'

// page-2
import BANKING_HERO_2 from "../Images/Courses/Banking and finance/banking-hero-2.png"
import  BANKING_COURSE_2  from "../Images/Courses/Banking and finance/banking-courses-2.png"
// page-3
import BANKING_HERO_3 from "../Images/Courses/Banking and finance/banking-hero-3.png"
import  BANKING_COURSE_3  from "../Images/Courses/Banking and finance/banking-courses-3.png"
// page-4
import BANKING_HERO_4 from "../Images/Courses/Banking and finance/banking-hero-4.png"
import  BANKING_COURSE_4  from "../Images/Courses/Banking and finance/banking-courses-4.png"

// software engneering
// page-1
import SOFTWARE_HERO_1 from "../Images/Courses/Software engineer/software-hero-1.png"
import SOFTWARE_COURSES_1 from "../Images/Courses/Software engineer/software-courses-1.png"
// page-2
import SOFTWARE_HERO_2 from "../Images/Courses/Software engineer/software-hero-2.png"
import SOFTWARE_COURSES_2 from "../Images/Courses/Software engineer/software-courses-2.png"
// page-3
import SOFTWARE_HERO_3 from "../Images/Courses/Software engineer/software-hero-3.png"
import SOFTWARE_COURSES_3 from "../Images/Courses/Software engineer/software-courses-3.png"
// page-4
import SOFTWARE_HERO_4 from "../Images/Courses/Software engineer/software-hero-4.png"
import SOFTWARE_COURSES_4 from "../Images/Courses/Software engineer/software-courses-4.png"
// page-5
import SOFTWARE_HERO_5 from "../Images/Courses/Software engineer/software-hero-5.png"
import SOFTWARE_COURSES_5 from "../Images/Courses/Software engineer/software-courses-5.png"
// page-6
import SOFTWARE_HERO_6 from "../Images/Courses/Software engineer/software-hero-6.png"
import SOFTWARE_COURSES_6 from "../Images/Courses/Software engineer/software-courses-6.png"
// page-7
import SOFTWARE_HERO_7 from "../Images/Courses/Software engineer/software-hero-7.png"
import SOFTWARE_COURSES_7 from "../Images/Courses/Software engineer/software-courses-7.png"
// page-8
import SOFTWARE_HERO_8 from "../Images/Courses/Software engineer/software-hero-8.png"
import SOFTWARE_COURSES_8 from "../Images/Courses/Software engineer/software-courses-8.png"
// page-9
import SOFTWARE_HERO_9 from "../Images/Courses/Software engineer/software-hero-9.png"
import SOFTWARE_COURSES_9 from "../Images/Courses/Software engineer/software-courses-9.png"
// data science
// page1
import DATA_HERO_1 from "../Images/Courses/Data science/data-hero-1.png"
import DATA_COURSES_1 from "../Images/Courses/Data science/data-courses-1.png"
// page2
import DATA_HERO_2 from "../Images/Courses/Data science/data-hero-2.png"
import DATA_COURSES_2 from "../Images/Courses/Data science/data-courses-2.png"
// page3
import DATA_HERO_3 from "../Images/Courses/Data science/data-hero-3.png"
import DATA_COURSES_3 from "../Images/Courses/Data science/data-courses-3.png"
// 
import DATA_HERO_4 from "../Images/Courses/Data science/data-hero-4.png"
import DATA_COURSES_4 from "../Images/Courses/Data science/data-courses-4.png"

// Digital marketing
// page1
 
import DIGITAL_HERO_1 from '../Images/Courses/Digital marketing/digitalhero-1.png'
import DIGITAL_HERO_2 from '../Images/Courses/Digital marketing/digitalhero-2.png'
import DIGITAL_HERO_3 from '../Images/Courses/Digital marketing/digitalhero-3.png'
import DIGITAL_HERO_4 from '../Images/Courses/Digital marketing/digitalhero-4.png'
import DIGITAL_HERO_5 from '../Images/Courses/Digital marketing/digitalhero-5.png'

import DIGITAL_COURSES_1 from '../Images/Courses/Digital marketing/digitalcourse-1.png'
import DIGITAL_COURSES_2 from '../Images/Courses/Digital marketing/digitalcourse-2.png'
import DIGITAL_COURSES_3 from '../Images/Courses/Digital marketing/digitalcourse-3.png'
import DIGITAL_COURSES_4 from '../Images/Courses/Digital marketing/digitalcourse-4.png'
import DIGITAL_COURSES_5 from '../Images/Courses/Digital marketing/digitalcourse-5.png'

// cyber security
import CYBER_HERO_1 from '../Images/Courses/Cyber security/cyber-hero-1.png'
import CYBER_HERO_2 from '../Images/Courses/Cyber security/cyber-hero-2.png'

import CYBER_COURSES_1 from '../Images/Courses/Cyber security/cyber-courses-1.png'
import CYBER_COURSES_2 from '../Images/Courses/Cyber security/cyber-courses-2.png'

// cloud computing

import CLOUD_HERO from '../Images/Courses/Cloud Computing/cloud-hero.png'
import CLOUD_COURSES from '../Images/Courses/Cloud Computing/cloud-courses.png'

// certification
import CERTIFICATION_HERO_1 from '../Images/Courses/Certification/hero-1.png'
import CERTIFICATION_HERO_2 from '../Images/Courses/Certification/hero-2.png'
import CERTIFICATION_HERO_3 from '../Images/Courses/Certification/hero-3.png'
import CERTIFICATION_HERO_4 from '../Images/Courses/Certification/hero-4.png'
import CERTIFICATION_HERO_5 from '../Images/Courses/Certification/hero-5.png'

import CERTIFICATION_COURSES_1 from '../Images/Courses/Certification/courses-1.png'
import CERTIFICATION_COURSES_2 from '../Images/Courses/Certification/courses-2.png'
import CERTIFICATION_COURSES_3 from '../Images/Courses/Certification/courses-3.png'
import CERTIFICATION_COURSES_4 from '../Images/Courses/Certification/courses-4.png'
import CERTIFICATION_COURSES_5 from '../Images/Courses/Certification/courses-5.png'

import CERTIFICATION_ACCORDIAN_1 from '../Images/Courses/Certification/accordian-1.png'
import CERTIFICATION_ACCORDIAN_2 from '../Images/Courses/Certification/accordian-2.png'
import CERTIFICATION_ACCORDIAN_3 from '../Images/Courses/Certification/accordian-3.png'
import CERTIFICATION_ACCORDIAN_4 from '../Images/Courses/Certification/accordian-4.png'
import CERTIFICATION_ACCORDIAN_5 from '../Images/Courses/Certification/accordian-5.png'

// design
import DESIGN_HERO_1 from '../Images/Courses/Design/hero-1.png'
import DESIGN_HERO_2 from '../Images/Courses/Design/hero-2.png'
import DESIGN_HERO_3 from '../Images/Courses/Design/hero-3.png'
import DESIGN_COURSES_1 from '../Images/Courses/Design/courses-1.png'
import DESIGN_COURSES_2 from '../Images/Courses/Design/courses-2.png'
import DESIGN_COURSES_3 from '../Images/Courses/Design/courses-3.png'
import DESIGN_ACCORDIAN_1 from '../Images/Courses/Design/accordian-1.png'
import DESIGN_ACCORDIAN_2 from '../Images/Courses/Design/accordian-2.png'
import DESIGN_ACCORDIAN_3 from '../Images/Courses/Design/accordian-3.png'

// Agile and scrum
import AGILE_HERO_1 from '../Images/Courses/Agile and scrum/hero-1.png'
import AGILE_HERO_2 from '../Images/Courses/Agile and scrum/hero-2.png'
import AGILE_COURSES_1 from '../Images/Courses/Agile and scrum/courses-1.png'
import AGILE_COURSES_2 from '../Images/Courses/Agile and scrum/courses-2.png'
import AGILE_ACCORDIAN_1 from '../Images/Courses/Agile and scrum/accordian-1.png'
import AGILE_ACCORDIAN_2 from '../Images/Courses/Agile and scrum/accordian-2.png'


// software accordian

import SOFTWARE_ACCORDIAN_1 from '../Images/Courses/Software engineer/accordian-1.png'
import SOFTWARE_ACCORDIAN_2 from '../Images/Courses/Software engineer/accordian-2.png'
import SOFTWARE_ACCORDIAN_3 from '../Images/Courses/Software engineer/accordian-3.png'
import SOFTWARE_ACCORDIAN_4 from '../Images/Courses/Software engineer/accordian-4.png'
import SOFTWARE_ACCORDIAN_5 from '../Images/Courses/Software engineer/accordian-5.png'
import SOFTWARE_ACCORDIAN_6 from '../Images/Courses/Software engineer/accordian-6.png'
import SOFTWARE_ACCORDIAN_7 from '../Images/Courses/Software engineer/accordian-7.png'
import SOFTWARE_ACCORDIAN_8 from '../Images/Courses/Software engineer/accordian-8.png'
import SOFTWARE_ACCORDIAN_9 from '../Images/Courses/Software engineer/accordian-9.png'

// digital accordian
import DIGITAL_ACCORDIAN_1 from '../Images/Courses/Digital marketing/accordian-1.png'
import DIGITAL_ACCORDIAN_2 from '../Images/Courses/Digital marketing/accordian-2.png'
import DIGITAL_ACCORDIAN_3 from '../Images/Courses/Digital marketing/accordian-3.png'
import DIGITAL_ACCORDIAN_4 from '../Images/Courses/Digital marketing/accordian-4.png'
import DIGITAL_ACCORDIAN_5 from '../Images/Courses/Digital marketing/accordian-5.png'

// Data science
import DATA_ACCORDIAN_1 from '../Images/Courses/Data science/accordian-1.png'
import DATA_ACCORDIAN_2 from '../Images/Courses/Data science/accordian-2.png'
import DATA_ACCORDIAN_3 from '../Images/Courses/Data science/accordian-3.png'
import DATA_ACCORDIAN_4 from '../Images/Courses/Data science/accordian-4.png'

// cyber
import CYBER_ACCORDIAN_1 from '../Images/Courses/Cyber security/accordian-1.png'
import CYBER_ACCORDIAN_2 from '../Images/Courses/Cyber security/accordian-2.png'

// cloud
import CLOUD_ACCORDIAN from '../Images/Courses/Cloud Computing/accordian.png'

import PLAY_ICON from '../Images/common/play_circle.svg'

import EDIT_ICON from '../Images/common/editIcon.svg'

import FACEBOOK_ICON from '../Images/common/basil_facebook-solid.svg'
import TWITTER_ICON from '../Images/common/prime_twitter.svg'
import INSTAGRAM_ICON from '../Images/common/mdi_instagram.svg'
import LINKEDIN_ICON from '../Images/common/ri_linkedin-fill.svg'

import MAIL_ICON from '../Images/common/mail.svg'
import CALL_ICON from '../Images/common/call.svg'

import CONTACT_MAIN from '../Images/common/contact-main.png'

import SIGNIN_MAIN from '../Images/common/signin-image.png'

import PASSWORDOPEN from '../Images/common/PasswordOpen.svg'
import PASSWORDCLOSE from '../Images/common/PasswordClosed.svg'

import GOOGLE_ICON from '../Images/common/Google.svg'
import FACEBOOK_ICON_LOGIN from '../Images/common/Facebook.svg'
import APPLE_ICON from '../Images/common/Apple.svg'
import CLOSE_ICON from '../Images/common/CloseIcon.svg'

import PROFILE_ICON from '../Images/common/Account_Image.svg'

import { ReactComponent as DASHBOARD_ICON} from '../Images/common/DashboardIcon.svg'
import { ReactComponent as COURSES_ICON} from '../Images/common/Courses Icon.svg'
import { ReactComponent as ANNOUNCEMENTS_ICON} from '../Images/common/AnnouncementsIcon.svg'
import { ReactComponent as CERTIFICATES_ICON} from '../Images/common/CertificatesIcon.svg'
import { ReactComponent as LIVESESSION_ICON} from '../Images/common/LiveSessionsIcon.svg'
import { ReactComponent as RECORDED_ICON} from '../Images/common/RecordingsIcon.svg'
import { ReactComponent as PROGRESS_ICON} from '../Images/common/ProgressIcon.svg'
import { ReactComponent as FEEDBACK_ICON} from '../Images/common/FeedbackIcon.svg'
import { ReactComponent as ACCOUNT_ICON} from '../Images/common/AccountIcon.svg'
import { ReactComponent as LOGOUT_ICON} from '../Images/common/logout.svg'

import{ReactComponent as TOTAL_COURSES} from '../Images/common/TotalCourses.svg'
import{ReactComponent as TOTAL_MATERIALS} from '../Images/common/TotalMaterials.svg'

import DASHBOARD_COURSE from '../Images/Dashboard/course.png'
import DASHBOARD_CERTIFICATE from '../Images/Dashboard/certificate.png'

//Continue Learning
import INTROJS from '../Images/Dashboard/Introduction to Js.png'
import MENU_ICON from '../Images/common/MenuIcon.svg'

import DASHBOARD_FRAME_PROFILE from '../Images/common/Frame 8882.png'

export const IMAGES ={
    DASHBOARD_COURSE,
    DASHBOARD_CERTIFICATE,

    SIGNIN_MAIN,

    SEARCH_ICON,
    EDUTECH_LOGO,
    HOME_HERO,
    CARD_IMG,

    PLAY_ICON,

    EDIT_ICON,

    DASHBOARD_FRAME_PROFILE,

    PARTNERS,

    HERO_MAIN_BAR,

    HOME_DEMO_1,
    HOME_DEMO_2,
    HOME_DEMO_3,

    HOME_ICON_1,
    HOME_ICON_2,
    HOME_ICON_3,
    HOME_ICON_4,

    HOME_BUSINESS_HERO,
    HOME_BUSSINESS_ASIDE,

    HOME_UNIVERSITY_HERO,
    HOME_UNIVERSITY_LEFT_ASIDE,
    HOME_UNIVERSITY_RIGHT_ASIDE,

    TRAINING_HERO,
    

    ABOUT_HERO,
    ABOUT_ICON,
    ABOUT_ASIDE,
    ABOUT_ARROW_ICON,

    CHEVRON_DOWN,
    CHEVRON_UP,
    CHEVRON_RIGHT,

    FACEBOOK_ICON,
    INSTAGRAM_ICON,
    TWITTER_ICON,
    LINKEDIN_ICON,
    

COURSE_ICON_1,
COURSE_ICON_2,
COURSE_ICON_3,
COURSE_ICON_4,
COURSE_ICON_5,
COURSE_ICON_6,
COURSE_ICON_7,
COURSE_ICON_8,
COURSE_ICON_9,



    BANKING_HERO_1,
    BANKING_COURSE_1,
    BANKING_ICON_1,
    BANKING_ACCORDIAN_1,
    BANKING_ACCORDIAN_2,
    BANKING_ACCORDIAN_3,
    BANKING_ACCORDIAN_4,

    BANKING_ICON_2,
    BANKING_ICON_3,
    BANKING_ICON_4,
    BANKING_ICON_5,
    BANKING_ICON_6,
    BANKING_ICON_7,
    BANKING_HERO_2,
    BANKING_COURSE_2,
    BANKING_HERO_3,
    BANKING_COURSE_3,
    BANKING_HERO_4,
    BANKING_COURSE_4,
    SOFTWARE_HERO_1,
    SOFTWARE_COURSES_1,
    SOFTWARE_HERO_2,
    SOFTWARE_COURSES_2,
    SOFTWARE_HERO_3,
    SOFTWARE_COURSES_3,
    SOFTWARE_HERO_4,
    SOFTWARE_COURSES_4,
    SOFTWARE_HERO_5,
    SOFTWARE_COURSES_5,
    SOFTWARE_HERO_6,
    SOFTWARE_COURSES_6,
    SOFTWARE_HERO_7,
    SOFTWARE_COURSES_7,
    SOFTWARE_HERO_8,
    SOFTWARE_COURSES_8,
    SOFTWARE_HERO_9,
    SOFTWARE_COURSES_9,
    DATA_HERO_1,
    DATA_COURSES_1,
    DATA_HERO_2,
    DATA_COURSES_2,
    DATA_HERO_3,
    DATA_COURSES_3,
    DATA_HERO_4,
    DATA_COURSES_4,

    DIGITAL_HERO_1,
    DIGITAL_HERO_2,
    DIGITAL_HERO_3,
    DIGITAL_HERO_4,
    DIGITAL_HERO_5,
    
    DIGITAL_COURSES_1,
    DIGITAL_COURSES_2,
    DIGITAL_COURSES_3,
    DIGITAL_COURSES_4,
    DIGITAL_COURSES_5,

    CYBER_HERO_1,
    CYBER_HERO_2,

    CYBER_COURSES_1,
    CYBER_COURSES_2,

    CLOUD_HERO,
    CLOUD_COURSES,

    CERTIFICATION_HERO_1,
    CERTIFICATION_HERO_2,
    CERTIFICATION_HERO_3,
    CERTIFICATION_HERO_4,
    CERTIFICATION_HERO_5,
    CERTIFICATION_COURSES_1,
    CERTIFICATION_COURSES_2,
    CERTIFICATION_COURSES_3,
    CERTIFICATION_COURSES_4,
    CERTIFICATION_COURSES_5,
    CERTIFICATION_ACCORDIAN_1,
    CERTIFICATION_ACCORDIAN_2,
    CERTIFICATION_ACCORDIAN_3,
    CERTIFICATION_ACCORDIAN_4,
    CERTIFICATION_ACCORDIAN_5,

    DESIGN_HERO_1,
    DESIGN_HERO_2,
    DESIGN_HERO_3,
    DESIGN_COURSES_1,
    DESIGN_COURSES_2,
    DESIGN_COURSES_3,
    DESIGN_ACCORDIAN_1,
    DESIGN_ACCORDIAN_2,
    DESIGN_ACCORDIAN_3,

    AGILE_HERO_1,
    AGILE_HERO_2,
    AGILE_COURSES_1,
    AGILE_COURSES_2,
    AGILE_ACCORDIAN_1,
    AGILE_ACCORDIAN_2,

    SOFTWARE_ACCORDIAN_1,
    SOFTWARE_ACCORDIAN_2,
    SOFTWARE_ACCORDIAN_3,
    SOFTWARE_ACCORDIAN_4,
    SOFTWARE_ACCORDIAN_5,
    SOFTWARE_ACCORDIAN_6,
    SOFTWARE_ACCORDIAN_7,
    SOFTWARE_ACCORDIAN_8,
    SOFTWARE_ACCORDIAN_9,
    DIGITAL_ACCORDIAN_1,
    DIGITAL_ACCORDIAN_2,
    DIGITAL_ACCORDIAN_3,
    DIGITAL_ACCORDIAN_4,
    DIGITAL_ACCORDIAN_5,
    DATA_ACCORDIAN_1,
    DATA_ACCORDIAN_2,
    DATA_ACCORDIAN_3,
    DATA_ACCORDIAN_4,
    CYBER_ACCORDIAN_1,
    CYBER_ACCORDIAN_2,
    CLOUD_ACCORDIAN,



    MAIL_ICON,
    CALL_ICON,
    
    CONTACT_MAIN,

    CALENDER_ICON,
    LIVE_ICON,
    VERIFIED_ROUNDED_ICON,
    PASSWORDOPEN,
    PASSWORDCLOSE,

    GOOGLE_ICON,
    APPLE_ICON,
    FACEBOOK_ICON_LOGIN,
    CLOSE_ICON,

    PROFILE_ICON,
    LOCK_ICON,


    DASHBOARD_ICON,
    COURSES_ICON,
    ANNOUNCEMENTS_ICON,
    CERTIFICATES_ICON,
    LIVESESSION_ICON,
    RECORDED_ICON,
    PROGRESS_ICON,
    FEEDBACK_ICON,
    ACCOUNT_ICON,
    LOGOUT_ICON,
    TOTAL_COURSES,
    TOTAL_MATERIALS,



    INTROJS,
    MENU_ICON,
    
} 